// extracted by mini-css-extract-plugin
export default {"numberBox":"styles_numberBox__8u5Fy","prefix":"styles_prefix__No4cb","inputBoxWithPrefix":"styles_inputBoxWithPrefix__1OBZr","inputBox":"styles_inputBox__BACgk"};